// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GridPreviewPopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Grid Popup Actions
 */
import { compose, withHandlers, withProps } from 'recompose';
import { curry } from 'lodash/fp';

/**
 * Handle close pop-up
 * @param {any} props
 * @param {any} e
 */
function onClosing(props: any, e: any): void {
  props.onAccept();
}

/**
 * Handle change metric on grid preview popup
 * @param {any} props
 * @param {any} e
 */
function onChangeGridPreviewPopupMetric(props: any, e: any): void {
  props.gridPreviewStore.updateShowingPartIndex(e.value);
}

/**
 * Build data for grid
 */
async function buildGridData(): Promise {
  const { reportPart, gridPreviewStore, shownRecords } = this.props;
  await gridPreviewStore.buildGridReportParts(reportPart, shownRecords);
  gridPreviewStore.turnOffProcessingDataIndicator.apply(gridPreviewStore);
  return Promise.resolve();
}

export default compose(
  withProps((): any => {
    return {
      buildGridData
    };
  }),
  withHandlers({
    onClosing: curry(onClosing),
    onChangeGridPreviewPopupMetric: curry(onChangeGridPreviewPopupMetric)
  })
);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.GridPreviewPopupActions.js